<template lang="pug">
div
  header
    .pull-right
      router-link.btn.btn-default(to="/admin/publications/new") New Publication
    h1 Publications

  table.table.table-striped(v-if="publications.length")
    thead
      tr
        th.id Id
        th.name Name
        th.slug Slug
        th.subsites Subsites
        th &nbsp;
    tbody
      tr(v-for="publication in publications" :key="publication.id")
        td.id {{ publication.id }}
        td.name
          router-link(:to="'/admin/publications/' + publication.id") {{ publication.name }}
        td.slug {{ publication.slug }}
        td.subsites {{ publication.subsites ? publication.subsites.length : 0 }}
        td.text-right
          .btn-group
            router-link.btn.btn-default(:to="`/admin/publications/${publication.id}/edit`")
              i.fa.fa-pencil
            button.btn.btn-danger(@click="confirmDelete(publication)")
              i.fa.fa-trash
  template(v-else)
    .alert.alert-info No publications found

</template>

<script setup>
  import { onBeforeMount } from 'vue'
  import { storeToRefs } from 'pinia'
  import { usePublicationsStore } from '@/stores/publications'

  const publicationsStore = usePublicationsStore()
  const { publications } = storeToRefs(publicationsStore)

  // TODO: the await call can be directly in the setup script once we upgrade to Vue 3
  onBeforeMount( async () => {
    await publicationsStore.fetch()
  })

  const confirmDelete = async (publication) => {
    if (confirm(`Sure you want to delete ${publication.name}?`)) {
      await publicationsStore.destroy({ publicationId: publication.id })
    }
  }
</script>
